module.exports = "/fonts/opensansitalic.woff2";